// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "assets/styling-" + {"52":"780d72b69c5b6fafd271","2639":"13b1f9488de580632831","6121":"6df7f8764d5cff01f02d","9563":"ebfcc38ac218efaa1365"}[chunkId] + ".css";
};